import * as React from 'react'
import { Text, View, TouchableOpacity, Linking } from 'react-native'

import Icon from '@components/icons/Icons'

import styled from '@theme/styled-components'
import { Animation } from '@components/root/Animators'

import Svg, { Defs, LinearGradient, Stop, Circle } from 'react-native-svg'

import useI18n from '@store/i18n/useI18n'
import config from '@app/config'

interface BackProps {
  available: boolean
}

const CircleBack = ({ available }: BackProps) => {
  return (
    <Svg height="100%" width="100%">
      <Defs>
        <LinearGradient id="grad" x1="0" y1="0" x2="100%" y2="100%">
          <Stop offset="0" stopColor={available ? '#3D61E0' : '#EDEEF1'} stopOpacity="1" />
          <Stop offset="1" stopColor={available ? '#3D61E0' : '#EDEEF1'} stopOpacity="1" />
        </LinearGradient>
      </Defs>
      <Circle cx="50%" cy="50%" r="78" fill="url(#grad)" />
    </Svg>
  )
}

const PLUS_BUTTON_WIDTH = 40

const RestaurantHeaderRefill = () => {
  const i18n = useI18n()

  return (
    <Animation animation="fade">
      <MainContainer>
        <FillView />
        <ContentView>
          <Back>
            <CircleBack available />
          </Back>
          <TextContainer>
            <ChargeAmount>{i18n.t('components.card.charge')}</ChargeAmount>
            <Label>{i18n.t('components.card.onToqla')}</Label>
          </TextContainer>
        </ContentView>
        <Touchable activeOpacity={0.9} onPress={() => Linking.openURL(config.constants.toqlaLink)}>
          <Button>
            <Icon name="redirect" size={18} color="#fff" />
          </Button>
        </Touchable>
      </MainContainer>
    </Animation>
  )
}

export default RestaurantHeaderRefill

const MainContainer = styled(View)`
  flex-direction: row;
`
const ContentView = styled(View)`
  height: 156px;
  width: 156px;

  justify-content: flex-end;
  align-items: center;
`
const FillView = styled(View)`
  height: 156px;
  width: ${PLUS_BUTTON_WIDTH / 2}px;
`
const Back = styled(View)`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
`

// TEXT

const TextContainer = styled(View)`
  margin-bottom: 25px;
`

const Label = styled(Text)`
  ${props => props.theme.fonts.genericLabel};
  color: ${props => props.theme.colors.authInfo};
`

const ChargeAmount = styled(Text)`
  ${props => props.theme.fonts.genericLabel}
  color: ${props => props.theme.colors.counterPrimary};
  text-transform: uppercase;
  width: 80px;
  margin-bottom: 4px;
`

// BUTTON

const Touchable = styled(TouchableOpacity)`
  position: absolute;
  bottom: 40px;
  left: 0px;
`

const Button = styled(View)`
  height: ${PLUS_BUTTON_WIDTH}px;
  width: ${PLUS_BUTTON_WIDTH}px;
  border-radius: ${PLUS_BUTTON_WIDTH / 2}px;
  background-color: ${props => props.theme.colors.secondary};

  align-items: center;
  justify-content: center;
`
